<template>
    <div v-if="show">
        <div class="mask" v-if="mask"></div>
        <div class="mint-spinner-snake"></div>
    </div>
</template>

<script>
    import Index from './index.js';
    export default Index;
</script>


<style lang="less">
    @import './index.less';
</style>



// WEBPACK FOOTER //
// src/ui/loading/index.vue